function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(-23 -15)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Stroke_1",
  "data-name": "Stroke 1",
  d: "M1.753,0S0,12.126,0,19.708C0,29.829,4.608,31.424,7.189,31.424s7.189-1.595,7.189-11.716C14.377,12.126,12.625,0,12.625,0Z",
  transform: "translate(24 16)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_3",
  "data-name": "Stroke 3",
  d: "M.259,0V20.386",
  transform: "translate(31 48)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_5",
  "data-name": "Stroke 5",
  d: "M14.377.259H0",
  transform: "translate(24 68)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var SvgIconWineSparkling = function SvgIconWineSparkling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.377,
    height: 54.259,
    viewBox: "0 0 16.377 54.259",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWineSparkling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wine-sparkling.643e6da2.svg";
export { ForwardRef as ReactComponent };